var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1661 1659",
    style: {
      enableBackground: "new 0 0 1661 1659"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A2A2A2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "baron"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M949.5,0c0,0,325.2,472.9,172.7,562.1C970.9,650.5,832.8,405,830.5,401l0,0l0,0l0,0 c-2.2,4-140.4,249.6-291.6,161.1C386.3,472.9,711.5,0,711.5,0S160.4,239.8,0,398.1c0,0,136,328.1,196.4,408.6 c0,0,215.8,729.1,405.8,852.3v-204.8h456.7V1659c189.9-123.2,405.8-852.3,405.8-852.3C1525,726.1,1661,398,1661,398 C1500.5,239.8,949.5,0,949.5,0z M764.3,764.7c36.3-36.4,95.2-36.5,131.5-0.2c36.4,36.3,36.5,95.2,0.2,131.5 c-36.3,36.4-95.1,36.5-131.5,0.2C728.1,860,728,801.1,764.3,764.7C764.3,764.7,764.3,764.7,764.3,764.7z M603.6,1057.6 c-36.4-36.3-36.5-95.2-0.2-131.5s95.2-36.5,131.5-0.2c36.4,36.3,36.5,95.1,0.2,131.5C698.9,1093.8,640,1093.9,603.6,1057.6 C603.7,1057.6,603.6,1057.6,603.6,1057.6z M896.6,1218.4c-36.3,36.4-95.2,36.5-131.5,0.2s-36.5-95.2-0.2-131.5 c36.3-36.4,95.1-36.5,131.5-0.2C932.8,1123.1,932.9,1182,896.6,1218.4C896.7,1218.4,896.7,1218.4,896.6,1218.4L896.6,1218.4z  M1057.5,1057.1c-36.3,36.4-95.2,36.5-131.5,0.2s-36.5-95.2-0.2-131.5c36.3-36.4,95.1-36.5,131.5-0.2 C1093.7,961.8,1093.8,1020.6,1057.5,1057.1C1057.5,1057,1057.5,1057,1057.5,1057.1L1057.5,1057.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaron);
export default __webpack_public_path__ + "static/media/baron.8abe143ab8783f64bb289043bf2a51f6.svg";
export { ForwardRef as ReactComponent };